const actionTypes = require('constants/actionTypes');

const ShowhireSolidarityCardView = () => {
    return {
        type: actionTypes.SHOW_HIRE_SOLIDATY_CARD_VIEW,
    };
};

const hideHireSolidarityCardView = () => {
    return {
        type: actionTypes.HIDE_HIRE_SOLIDATY_CARD_VIEW,
    };
};

export default {
    ShowhireSolidarityCardView,
    hideHireSolidarityCardView,
};
